import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSmsWebControl extends Layout {
    buttonInitializeAccount: Button;
    checkboxSaveImages: Checkbox;
    dataheader1: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    sourceDispatchControl: DataSource;
    sourceSmsControl: DataSource;
    switchCreateSmsCallin: Switch;
    switchOptInDefault: Switch;
    switchSmsIsActive: Switch;
    switchUpdateSchedCallTime: Switch;
    tabGeneral: Tab;
    tabMessaging: Tab;
    tabset1: Tabset;
    textboxApplicationId: Textbox;
    textboxCallbackUrl: Textbox;
    textboxCloser: Textbox;
    textboxDirectionDisclaimer: Textbox;
    textboxDoNotCallDiscclaimer: Textbox;
    textboxEmail: Textbox;
    textboxLocationId: Textbox;
    textboxNotificationMethod: Textbox;
    textboxRepliesTo: Textbox;
    textboxSenderId: Textbox;
    textboxSiteId: Textbox;
    textboxWebPassword: Textbox;
    textboxWebUsername: Textbox;
}
